// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uiEm","fullView":"styles_fullView__2KNC5"};